import { queryClient } from '@src/corelib/query';

import prefetchQuery from './prefetchQuery';
import useMutation from './useMutation';
import useQuery from './useQuery';

const activityUrl = 'activity/';
const absenceUrl = `${activityUrl}absence/`;
const absenceParams = {acti_type: 'absence'};

const typesUrl = `${activityUrl}types/`;
const absenceTypeParams = {acty_type: 'absence'};


const absToolResourcesUrl = 'users/abs_tool_resources/';


export function prefetchAbsToolResources(client) {
  prefetchQuery(absToolResourcesUrl, client);
};

export function useAbsToolResources() {
  const query = useQuery(absToolResourcesUrl);

  return {
    ...query,
  };
}

export function prefetchAbsences(client) {
  prefetchQuery(activityUrl, client, {queryParams: absenceParams});
};
export function useAbsences() {
  const query = useQuery(activityUrl, {queryParams: absenceParams});
  const {mutateAsync: bookAbsence} = useMutation({
    mutateFn: ({apiClient, ...rest }) => {
      return apiClient.request({url: absenceUrl, method: 'POST', payload: rest});
    },
    onSuccess: ({absences}) => {
      queryClient.setQueryData(query.queryKey, (old) => ([...old, ...absences]));
    },
  });
  const {mutateAsync: deleteAbsences} = useMutation({
    mutateFn: ({apiClient, ids}) => {
      return apiClient.request({
        url: absenceUrl,
        method: 'DELETE',
        payload: ids,
        bodyOnDelete: true,
      });
    },
    onSuccess: ({ absences }, { ids }) => {
      queryClient.setQueryData(query.queryKey, (old) => {
        const updatesById = new Map(absences.map((a) => [a.id, a]));
        const result = [];
        for (const item of old) {
          if (ids.includes(item.id)) {
            continue; 
          }
          const updated = updatesById.get(item.id);
          result.push(updated ?? item);
        }
        return result;
      });
    },
  });

  return {
    ...query,
    bookAbsence,
    deleteAbsences,
  };
}
export function prefetchAbsenceTypes(client) {
  prefetchQuery(typesUrl, client, {queryParams: absenceTypeParams});
};
export function useAbsenceTypes(client) {
  return useQuery(typesUrl, client, {queryParams: absenceTypeParams});
};
